import React from 'react'
import { showBillingDayPicker } from '../lib/billingPeriods'

interface BillingDayOfMonthSelectProps {
  value: number | null | undefined
  onChange: (day: number) => void
  billingFrequency?: string | null
  className?: string
  /** When false, always render (caller already gated). Default true. */
  hideWhenNotApplicable?: boolean
}

const DAY_OPTIONS: { value: number; label: string }[] = [
  ...Array.from({ length: 28 }, (_, i) => ({
    value: i + 1,
    label: `Day ${i + 1}`,
  })),
  { value: 31, label: 'Last day of month' },
]

/**
 * Picker for which day of the month a recurring period starts / is billed.
 * Default is day 1 (beginning of month). Advance billing: billed that day covering the period.
 */
export function BillingDayOfMonthSelect({
  value,
  onChange,
  billingFrequency,
  className = 'w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500',
  hideWhenNotApplicable = true,
}: BillingDayOfMonthSelectProps) {
  if (hideWhenNotApplicable && !showBillingDayPicker(billingFrequency)) {
    return null
  }

  const resolved = value && value >= 1 ? value : 1

  return (
    <div data-consistency-anchor="billing-day-of-month">
      <label className="block text-sm font-medium text-gray-700 mb-2">Bill on day of month</label>
      <select
        value={resolved}
        onChange={(e) => onChange(Number(e.target.value))}
        className={className}
      >
        {DAY_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      <p className="text-xs text-gray-500 mt-1">
        Billed on this day for the period that starts then (e.g. day 1 = July 1 covers July 1–31).
      </p>
    </div>
  )
}

export function formatBillingDayOfMonth(day: number | null | undefined): string {
  if (day == null || day < 1) return 'Day 1'
  if (day >= 31) return 'Last day of month'
  return `Day ${day}`
}
